import React, { type ReactNode } from "react";

export type OutcomeTooltipRow = {
  key: string;
  color: string;
  name: string;
  value: string;
  /** The formatted low–high band, shown under the value when set. */
  range?: string;
  rangeTestId?: string;
  /** Extra line under the row, such as the change against the baseline. */
  footer?: ReactNode;
};

/** The hover card every outcome chart and table cell shares: a header, then one row per scenario. */
export const OutcomeTooltip = ({ header, rows }: { header: string; rows: OutcomeTooltipRow[] }) => (
  <div className="outcome-comparison-tooltip">
    <div className="outcome-comparison-tooltip-header">{header}</div>
    <div className="outcome-comparison-tooltip-divider" aria-hidden />
    {rows.map((row) => (
      <div key={row.key} className="outcome-comparison-tooltip-row">
        <div className="outcome-comparison-tooltip-line">
          <span className="outcome-comparison-tooltip-dot" style={{ backgroundColor: row.color }} aria-hidden />
          <span className="outcome-comparison-tooltip-name">{row.name}</span>
          <span className="outcome-comparison-tooltip-value">{row.value}</span>
        </div>
        {row.range ? (
          <div className="outcome-comparison-tooltip-range" data-testid={row.rangeTestId}>
            {row.range}
          </div>
        ) : null}
        {row.footer}
      </div>
    ))}
  </div>
);
